import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player";
import { getUrlParams } from "../apiService/timespam";
import "./Theme.css";
import "./SessionsPlayer.css";

const SessionsPlayer = () => {
  const { t } = useTranslation();
  const { theme, lang } = getUrlParams();
  const urlParams = new URLSearchParams(window.location.search);
  const videoUrl = urlParams.get("url") || "";
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  return (
    <section className="player-page">
      <div className="player-wrapper">
        <ReactPlayer
          url={videoUrl}
          playing={playing}
          controls
          width="100%"
          height="100%"
          className="react-player"
        />
      </div>
      <div className="player-controls">
        <button className="player-btn" onClick={() => setPlaying((p) => !p)}>
          {playing ? t("player.pause") : t("player.play")}
        </button>
      </div>
    </section>
  );
};

export default SessionsPlayer;
